import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';

import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { SelectOrCreateFolderDialogComponent } from 'src/app/pages/accounting-folders/select-or-create-folder-dialog/select-or-create-folder-dialog.component';
import { environment } from 'src/environments/environment';
import { ConnectorsModule } from '~modules/connectors/connectors.module';
import { ConnectorEntity } from '~modules/connectors/entities/connector.entity';
import { GlobalConnectorsService } from '~modules/connectors/services/global-connectors.service';

@Component({
  selector: 'app-welcome',
  styleUrls: ['./welcome.component.scss'],
  templateUrl: './welcome.component.html',
  standalone: true,
  imports: [
    MatIconModule,
    ConnectorsModule,
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    RouterModule,
    MatSelectModule
  ]
})
export class WelcomeComponent {

  connectors$: Observable<ConnectorEntity[]>;

  constructor(
    private titleService: Title,
    private readonly connectorService: GlobalConnectorsService,
    private readonly dialog: MatDialog
  ) {
    this.titleService.setTitle('Accueil');
    this.connectors$ = this.connectorService.getAll();
  }

  get supportEmail() {
    return environment.supportEmail;
  }

  get calendarUrl() {
    return environment.calendarUrl;
  }

  openDialog(): void {
    this.dialog.open(SelectOrCreateFolderDialogComponent, {});
  }




}
